import React from "react";
import {
  BarChart2,
  GitBranch,
  Clock,
  ListTodo,
  Database,
  PieChart,
  Workflow,
  Timer,
} from "lucide-react";
import SC from "./style";

function AllProjectCard() {
  const features = [
    {
      icon: <BarChart2 size={24} color="white" />,
      text: "Gantt Charts & Kanban Boards",
      color: "#22c55e",
    },
    {
      icon: <Workflow size={24} color="white" />,
      text: "Custom Workflows",
      color: "#3b82f6",
    },
    {
      icon: <GitBranch size={24} color="white" />,
      text: "Agile Workflow",
      color: "#f59e0b",
    },
    {
      icon: <Clock size={24} color="white" />,
      text: "Timeline",
      color: "#ef4444",
    },
    {
      icon: <Database size={24} color="white" />,
      text: "AI-Powered Insights & Reports",
      color: "#06b6d4",
    },
    {
      icon: <PieChart size={24} color="white" />,
      text: "Analytics",
      color: "#14b8a6",
    },
    {
      icon: <ListTodo size={24} color="white" />,
      text: "Roadmap",
      color: "#8b5cf6",
    },
    {
      icon: <Timer size={24} color="white" />,
      text: "Sprint",
      color: "#ec4899",
    },
  ];

  return (
    <SC.Container>
      <SC.Title>All-in-One Project Management Software</SC.Title>
      <SC.Subtitle>
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua"
      </SC.Subtitle>
      <SC.FeaturesGrid>
        {features.map((feature, index) => (
          <SC.FeatureCard key={index}>
            <SC.IconWrapper color={feature.color}>
              {feature.icon}
            </SC.IconWrapper>
            <SC.FeatureText>{feature.text}</SC.FeatureText>
          </SC.FeatureCard>
        ))}
      </SC.FeaturesGrid>
    </SC.Container>
  );
}

export default AllProjectCard;
